import { getNewsFromApi, getNewsFromCms } from 'application/adapters/cms/newsAdapter';

export interface NewsQuery {
	rootId?: number;
	limit?: number;
	offset?: number;
	preview?: boolean;
	previewData?: Content.PreviewData;
	filter?: string;
}

export const getNews = async (query: NewsQuery): Promise<News.NewsArticle[]> => {
	if (typeof window === 'undefined') {
		//Server side
		return await getNewsFromCms(query.rootId, query.limit, query.offset, query.preview, query.previewData, query.filter);
	} else {
		//Client side
		return await getNewsFromApi(query.rootId, query.limit, query.offset, query.preview, query.previewData, query.filter);
	}
};
